import { Table } from 'antd'
import { shippingColumn } from '../../customers/column'

const ShippingTable = ({ data, setData, setOpen, setoOpenDeleteModal }) => {
  return (
    <div>
        <Table dataSource={data || []} columns={shippingColumn(setData, setOpen, setoOpenDeleteModal)} pagination={false} />
    </div>
  )
}

export default ShippingTable
